import { z } from 'zod';

// === Privacy Statement Schema ===
// Ported from Click2Gro PHP: privacy_statement table (Admin product library)
// Two possible types: "Privacy" (Privacy Statement PDF) | "Terms" (Terms & Conditions PDF)
// The `url` field stores a Supabase Storage filename or an external HTTPS URL.

export const PRIVACY_STATEMENT_TYPES = ['Privacy', 'Terms'] as const;
export type PrivacyStatementType = (typeof PRIVACY_STATEMENT_TYPES)[number];

export const PrivacyStatementSchema = z.object({
  id:          z.number().int().positive(),
  description: z.enum(PRIVACY_STATEMENT_TYPES).nullable(),
  url:         z.string().nullable(),
  created_at:  z.string().nullable(),
  created_by:  z.string().max(300).nullable(),
  updated_at:  z.string().nullable(),
  updated_by:  z.string().max(300).nullable(),
  deleted_at:  z.string().nullable(),
});

export type PrivacyStatement = z.infer<typeof PrivacyStatementSchema>;

export const PrivacyStatementInsertSchema = PrivacyStatementSchema.omit({
  id:         true,
  created_at: true,
  updated_at: true,
  deleted_at: true,
});
export type PrivacyStatementInsert = z.infer<typeof PrivacyStatementInsertSchema>;

export const PrivacyStatementUpdateSchema = PrivacyStatementInsertSchema.partial().required({});
export type PrivacyStatementUpdate = z.infer<typeof PrivacyStatementUpdateSchema>;
